<template>
  <div
    class="popupViewProfileCardImage"
    :style="hideBorder ? 'border:  none' : ''"
  >
    <div v-if="!data.avatar
    
    " class="networkSearchItemImage">
      <figure>
        <div
          class="img"
          :style="{
            backgroundImage: `url('${getAvatarLink(data.avatar, getDefaultAvatar(data.roleName))}')`
          }"
        ></div>
      </figure>
    </div>
    <div v-else class="popupProfileCardImage">
      <img :src="getThumbnailUrl(data.avatar)" alt="Thumbnail">
    </div>
    <div class="popupViewProfileCardImageText">
      <h3
        v-if="!hideCompany"
        style="color: #294A7A; font-size: 17px; font-weight: 400; margin-bottom: 4px;"
      >
        {{ data.company }}
      </h3>
      <h3 class="popupViewProfileCardImageTitle">
        {{ data.name }}
      </h3>
      <h5 class="popupViewProfileCardImageDesc">{{ data.phoneCompany }}</h5>
      <h5 class="popupViewProfileCardImageEmail">{{ data.email }}</h5>
      <MainButton
        v-if="data.homepage"
        btnText="홈페이지"
        customFontSize="16px"
        width="116px"
        customHeight="32px"
        target="_blank"
        :to="data.homepage"
      />
    </div>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import { resolveApiUrl } from "@/data/url";
export default {
  name: "CorpInfo",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    hideCompany: Boolean,
    hideHomepage: Boolean,
    hideBorder: Boolean,
  },
  components: { MainButton },
  methods: {
    getThumbnailUrl(avatar) {
      return resolveApiUrl(`/api/profile/${avatar}.jpg`);
    }
  },
};
</script>

<style>
    .popupProfileCardImage {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 200px;
    }
    .popupProfileCardImage img {
        max-width: 100%!important;
        max-height: 100%!important;
        object-fit: contain!important;
    }
</style>
